import { css, keyframes } from "styled-components";

export const opacityAnimation = keyframes`
   0% { opacity:0; }
  100% { opacity:1; }
`;

const gridGuideShadow = keyframes`
  0% {
    box-shadow: 0 0 0 1px rgba(0, 255, 0, 1);
  }
  100% {
    box-shadow: 0 0 0 0px rgba(0, 255, 0, 1);
  }
`;

export const defaultAnimation = () => css`${opacityAnimation} 0.15s ease-in;`;

export const gridGuideAnimation = () =>
  css`${gridGuideShadow} 1s ease-in;s
`;

export const tapTransition = () => css`opacity 0.15s ease-in;`;
